import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiForumListModule } from './fi-forum-list/fi-forum-list.module';
import { UIRouterModule } from '@uirouter/angular';
import { NewForumStates } from '@fi-shared/fi-forum/fi-forum-states';
import { FiForumSharedService } from '@fi-shared/fi-forum/fi-forum-shared.service';
import { FiForumViewModule } from '@fi-shared/fi-forum/fi-forum-view/fi-forum-view.module';
import { FiForumPostEditModule } from '@fi-shared/fi-forum/fi-forum-post-edit/fi-forum-post-edit.module';
import { FiForumPostViewModule } from '@fi-shared/fi-forum/fi-forum-post-view/fi-forum-post-view.module';

@NgModule({
    imports: [
        CommonModule,
        FiForumListModule,
        FiForumViewModule,
        FiForumPostViewModule,
        FiForumPostEditModule,
        UIRouterModule.forChild(NewForumStates),
    ],
    declarations: [],
    providers: [FiForumSharedService],
    exports: [FiForumListModule],
})
export class FiForumModule {}
